import { Component, OnInit, ViewChild } from '@angular/core';
import { UsersApp } from '../../models/usersApp.model';
import { Observable } from 'rxjs';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { UsersService } from 'src/app/services/users.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ExcelService } from '../../services/excel.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-users-page',
  templateUrl: './users-page.component.html',
  styleUrls: ['./users-page.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class UsersPageComponent implements OnInit {

  panelOpenState = false;
  expandedElement: UsersApp | null;
  displayedColumns: string[] = ['star', 'email', 'lastConnection' ];
  dataSource: MatTableDataSource<UsersApp>;
  filteredUsers: Observable<any>;

  users: UsersApp[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private _us: UsersService, private excelService: ExcelService, private dPipe: DatePipe) { }

  ngOnInit() {
    this._us.getAll().subscribe(data => {
      this.users = data;
      // Assign the data to the data source for the table to render
      this.dataSource = new MatTableDataSource(this.users);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  export() {
      const data: any = this.users.map((ui: any) => {
        return {
          Email: ui.email,
          'Last connection': this.dPipe.transform(ui.lastConnection.toDate(), 'dd/MM/yyyy HH:mm'),
          'Last device': ui.lastDevice,
          'Last device name': ui.lastDeviceName,
          'Last device platform': ui.lastDevicePlatform,
          'Last device version': ui.lastDeviceVersion,
          'Last app version': ui.lastAppVersion
        };
      });
      this.excelService.exportAsExcelFile(data, 'emails');
  }
}
